import { render, staticRenderFns } from "./FooterImageNav.vue?vue&type=template&id=a4023e86&scoped=true&"
import script from "./FooterImageNav.vue?vue&type=script&lang=ts&"
export * from "./FooterImageNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4023e86",
  null
  
)

export default component.exports